
import { Dialog, DialogContent, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { PDFPreview } from "./PDFPreview";

interface ResourceCardPreviewDialogProps {
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
  resourceId: string;
  topic: string;
  company: string;
  isTrainee: boolean;
  isAdmin?: boolean;
  isResourceCompleted: boolean;
  onComplete?: () => void;
  isMobile: boolean;
}

export function ResourceCardPreviewDialog({
  isOpen,
  onOpenChange,
  resourceId,
  topic,
  company,
  isTrainee,
  isAdmin = false,
  isResourceCompleted,
  onComplete,
  isMobile
}: ResourceCardPreviewDialogProps) {
  return (
    <Dialog open={isOpen} onOpenChange={onOpenChange}>
      <DialogContent className="w-full max-w-4xl h-auto p-0 overflow-hidden">
        <DialogTitle className="sr-only">Training Preview</DialogTitle>
        <DialogDescription className="sr-only">Training content and quiz</DialogDescription>
        <PDFPreview 
          resourceId={resourceId}
          topic={topic} 
          company={company}
          onComplete={onComplete}
        />
      </DialogContent>
    </Dialog>
  );
}
